module.exports = __webpack_public_path__ + "img/home_active_icon@2x.19000525.png";